module.exports = __webpack_public_path__ + "static/media/ofte.caf7397a.m4a";